import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { StaticDataType, StaticDataTypeDetail, StaticDataTypeParams } from './staticDataType.types';

export const getStaticDataTypeList = (client: AxiosInstance) => async (params: StaticDataTypeParams) => {
  return (await client.get<PaginatedApiResponse<StaticDataType[]>>(API_ROUTES.GET_STATIC_DATA_TYPE, { params })).data;
};

const getStaticDataTypeDetail = (client: AxiosInstance) => async (staticDataTypeId: string) =>
  (
    await client.get<ApiResponse<StaticDataTypeDetail>>(API_ROUTES.GET_STATIC_DATA_TYPE_DETAIL, {
      params: { staticDataTypeId },
    })
  ).data;

export const staticDataTypeQueries = {
  all: () => ['static-data-type'],
  list: (params: StaticDataTypeParams) =>
    queryFactoryOptions<PaginatedApiResponse<StaticDataType[]>>({
      queryKey: [...staticDataTypeQueries.all(), 'list', params],
      queryFn: (client) => () => getStaticDataTypeList(client)(params),
    }),
  details: (staticDataTypeId: string) =>
    queryFactoryOptions<ApiResponse<StaticDataTypeDetail>>({
      queryKey: [...staticDataTypeQueries.all(), 'details', staticDataTypeId],
      queryFn: (client) => () => getStaticDataTypeDetail(client)(staticDataTypeId),
    }),
};
